<template>
  <span class="moldura" :style="{ aspectRatio: proporcao }">
    <img
      :src="origemAtual"
      :class="{ 'imagem--visivel': carregada }"
      alt=""
      loading="lazy"
      decoding="async"
      draggable="false"
      referrerpolicy="no-referrer"
      @load="aoCarregar"
      @error="aoFalhar"
    >
  </span>
</template>

<script setup>
  import { ref, watch } from 'vue';

  const props = defineProps({
    origem: {
      type: String,
      required: true
    },
    rotulo: {
      type: String,
      required: true
    },
    corDeReserva: {
      type: String,
      default: '#d32f2f'
    },
    proporcao: {
      type: String,
      default: '4 / 3'
    }
  });

  function iniciais(texto) {
    return String(texto || '')
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map((palavra) => palavra[0])
      .join('')
      .toUpperCase();
  }

  /*
   * Boa parte das lojas nao tem imagem propria cadastrada no PrestaShop, entao
   * a reserva mantem o card legivel em vez de exibir imagem quebrada.
   */
  function imagemDeReserva() {
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300">
      <rect width="400" height="300" fill="${props.corDeReserva}"/>
      <circle cx="330" cy="40" r="90" fill="#ffffff" opacity="0.10"/>
      <circle cx="60" cy="270" r="70" fill="#ffffff" opacity="0.08"/>
      <text x="200" y="150" font-family="Inter, sans-serif" font-size="86"
        font-weight="700" fill="#ffffff" text-anchor="middle"
        dominant-baseline="central" opacity="0.92">${iniciais(props.rotulo)}</text>
    </svg>`;

    return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
  }

  const carregada = ref(false);
  /* Loja sem imagem cadastrada ja entra com a reserva, sem tentar carregar. */
  const origemAtual = ref(props.origem || imagemDeReserva());

  function aoCarregar() {
    carregada.value = true;
  }

  function aoFalhar() {
    const reserva = imagemDeReserva();

    if (origemAtual.value === reserva) return;

    origemAtual.value = reserva;
  }

  /* O componente e reaproveitado quando a listagem troca de item. */
  watch(() => props.origem, (nova) => {
    carregada.value = false;
    origemAtual.value = nova || imagemDeReserva();
  });
</script>

<style scoped>
  .moldura {
    display: block;
    position: relative;
    overflow: hidden;
    background: linear-gradient(110deg, #f2eef4 30%, #e8e2ec, #f2eef4 70%);
    background-size: 220% 100%;
    animation: brilho 1.4s linear infinite;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0;
    transition: opacity 0.4s ease, transform 0.5s var(--transicao-padrao);
  }

  .imagem--visivel {
    opacity: 1;
  }

  @keyframes brilho {
    to {
      background-position: -220% 0;
    }
  }
</style>
